@let cardClassName = strategy.cardClassName;

@if (cardClassName) {
  <section hlmCard [class]="cardClassName">
    <div hlmCardContent>
      <ng-container *ngTemplateOutlet="cardBody" />
    </div>
  </section>
} @else {
  <ng-container *ngTemplateOutlet="cardBody" />
}

<ng-template #cardBody>
  <div class="update-model-card__header">
    <ocp-themed-icon [name]="strategy.imgSrc" [size]="20" />
    <span>{{ strategy.title | translate }}</span>
  </div>

  @if (strategy.description) {
    <div class="update-model-card__description">
      {{ strategy.description | translate }}
    </div>
  }

  @if (items().length > 0) {
    <ul class="update-model-card__list">
      @for (item of visibleItems(); track item.id) {
        <li class="update-model-card__item">
          <div class="update-model-card__item-top">
            <div class="update-model-card__item-info">
              <span class="update-model-card__item-name">{{ item.name }}</span>
              <span class="update-model-card__item-meta">
                {{ item.created | date: 'yyyy-MM-dd HH:mm' }}
              </span>
              <span class="update-model-card__item-meta">
                {{ 'update-model-card.version' | translate }}: {{ item.latestRevision }}
              </span>
            </div>
            <div class="update-model-card__item-owner">
              <ocp-avatar
                [userInitials]="{ displayName: item.displayName || item.email } | initials"
                [colorSeed]="item.email"
                size="md"
              />
              <span class="update-model-card__item-owner-name">{{
                item.displayName || item.email
              }}</span>
            </div>
          </div>

          <div class="update-model-card__item-actions">
            <button
              hlmBtn
              type="button"
              variant="secondary"
              size="sm"
              (click)="onView(item)"
              [attr.aria-label]="('update-model-card.view' | translate) + ' ' + item.name"
            >
              <ocp-themed-icon name="open-in-new.svg" />
              {{ 'update-model-card.view' | translate }}
            </button>
            <button
              hlmBtn
              type="button"
              variant="secondary"
              size="sm"
              (click)="onUpdate(item)"
              [attr.aria-label]="('update-model-card.update' | translate) + ' ' + item.name"
            >
              <ocp-themed-icon name="refresh-circled.svg" />
              {{ 'update-model-card.update' | translate }}
            </button>
          </div>
        </li>
      }
    </ul>

    @if (hasMoreItems()) {
      <button
        hlmBtn
        type="button"
        variant="link"
        size="lg"
        class="update-model-card__toggle"
        [attr.aria-expanded]="isExpanded()"
        (click)="toggleExpanded()"
      >
        @if (isExpanded()) {
          {{ 'update-model-card.show-less' | translate }}
          <ocp-themed-icon name="ArrowHeadUp.svg" [size]="12" />
        } @else {
          {{ 'update-model-card.show-more' | translate }}
          <ocp-themed-icon name="ArrowHeadDown.svg" [size]="12" />
        }
      </button>
    }
  }
</ng-template>
